// extracted by mini-css-extract-plugin
export default {"h3":"vp_qKL8W","marginNone":"vp_c9Oqa"};